export default __webpack_public_path__ + "static/media/money-time.4f3fb131.svg";